// import UfpCoreConstants from './UfpCoreConstants'

// old method trying to keep ufp node but it makes things far too complicated
// const getUfpState = (state) => state[UfpCoreConstants.STATE_NAME]
// so just return state
const getUfpState = (state) => state

export default {
    getUfpState
}
